export const PRICE_MAJOR_MINOR_UNIT_TOOLTIP = `Unit type defines what 'Major' and 'Minor' mean:
Daily: days
Weekly: weeks (Major), days (Minor)
Monthly: months (Major)`;